
import {API_CAPTCHA_MONITOR} from '@/enmus/PageNames';
export default {
    // vue-cli对api前缀做了特殊处理，需要加_做区分
    path: 'captcha',
    name: API_CAPTCHA_MONITOR,
    component: () => import('@/views/dataReport/captchaMonitor/index.vue'),
    meta: {
        name: API_CAPTCHA_MONITOR,
        title: '验证码监控'
    }
};